/**
 * 扩展富文本组件
 */
import React from "react";
import { connect } from "dva";
import { parse } from "querystring";
import { framework_tool, component_tool } from "@/tool";
import { WizTableForm } from "@/containers/common";
import { CustomTabs } from "@/components";
import './index.less'

const { WizBraftEditor, WizIcon } = component_tool;
const { braftUtils } = WizBraftEditor;
const { WizContainer, modelUtils, WizOssUpload } = framework_tool;


class WizBraftEditorPlus extends WizContainer {

  componentName = "WizBraftEditorPlus";

  constructor(props) {
    super(props);
    this.state = {
      editorState: WizBraftEditor.createEditorState(null),
      filterItems: [],
      linkItems: [
        { name: 'program', title: '课程', content: <TabForm name="program" onSelectedRows={this.onSelectedRows} params={{ status: 1 }} />, href: '/#/programDetail' },
        { name: 'exam', title: '考试', content: <TabForm name="exam" onSelectedRows={this.onSelectedRows} params={{ status: 1 }} />, href: '/#/examDetail' },
        { name: 'apply', title: '报名', content: <TabForm name="apply" onSelectedRows={this.onSelectedRows} params={{ status: 1 }} />, href: '/#/applyDetail' },
        { name: 'task', title: '任务', content: <TabForm name="task" onSelectedRows={this.onSelectedRows} params={{ stateIds: [0, 1] }} />, href: '/#/taskCenter' },
      ],
    };
    this.activeKey = "0";
  }

  _componentDidMount() {
    const { links, value } = this.props
    const { linkItems } = this.state
    const _linkItems = links.map(val => linkItems[val])
    this.setState({ filterItems: _linkItems, editorState: WizBraftEditor.createEditorState(value) })
  }


  /**
   * 重新设置富文本内容
   */
  resetContent = (value) => {
    this.setState({ editorState: WizBraftEditor.createEditorState(value) })
  }

  // 内链数据表格选中某一行
  onSelectedRows = (rows) => {
    this.selectedRows = rows;
  };

  // 内链数据表格选中某一行点击确定按钮事件
  handleOk = () => {
    const { filterItems, editorState } = this.state;
    let _href = filterItems.filter((val, index) => index.toString() === this.activeKey)[0].href;
    let href = ''
    if (this.selectedRows && this.selectedRows.length) {
      let row = this.selectedRows[0]
      if (row['bizType'] !== 15) {
        href = constants.env.sys_user_url + _href + '?id=' + row['id']
      } else {
        href = constants.env.sys_user_url + _href + '?name=' + row['name']
      }
    } else {
      return
    }
    const _value = `<div>
      <span style="color:#666"></span>
      <a href="${href}" target="_blank" style="font-size:16px;color:#1890ff;cursor: pointer">${this.selectedRows[0].name || this.selectedRows[0].title}</a>
      <span style="color:#666"></span>
      </div>`;
    this.setState({
      editorState: braftUtils.ContentUtils.insertHTML(editorState, _value),
      key: new Date().getTime(),
    });
    this.activeKey = "0";
  };

  // 富文本框onChange事件
  handleChange = (editorState) => {
    const { onChange } = this.props;
    this.setState({ editorState });
    onChange && onChange(editorState.toHTML());
  };

  // 预览
  handlePreview = () => {
    const buildPreviewHtml = () => {
      return `
        <!Doctype html>
        <html>
          <head>
            <title>Preview Content</title>
            <style>
              html,body{
                height: 100%;
                margin: 0;
                padding: 0;
                overflow: auto;
                background-color: #f1f2f3;
              }
              .container{
                box-sizing: border-box;
                width: 1000px;
                max-width: 100%;
                min-height: 100%;
                margin: 0 auto;
                padding: 30px 20px;
                overflow: hidden;
                background-color: #fff;
                border-right: solid 1px #eee;
                border-left: solid 1px #eee;
              }
              .container img,
              .container audio,
              .container video{
                max-width: 100%;
                height: auto;
              }
              .container p{
                white-space: pre-wrap;
                min-height: 1em;
              }
              .container pre{
                padding: 15px;
                background-color: #f1f1f1;
                border-radius: 5px;
              }
              .container blockquote{
                margin: 0;
                padding: 15px;
                background-color: #f1f1f1;
                border-left: 3px solid #d1d1d1;
              }
            </style>
          </head>
          <body>
            <div class="container">${this.state.editorState.toHTML()}</div>
          </body>
        </html>
      `;
    }
    if (window.previewWindow) {
      window.previewWindow.close();
    }

    window.previewWindow = window.open();
    window.previewWindow.document.write(buildPreviewHtml());
    window.previewWindow.document.close();
  }

  /**
   * 添加图片
   */
  addImg = (files) => {
    let file = files[files.length - 1]
    if (file && file.status === 'done') {
      this.setState({
        editorState: braftUtils.ContentUtils.insertMedias(this.state.editorState, [{
          type: 'IMAGE',
          url: getOssFilePath(file['fileId'])
        }])
      })
    }
  };

  /**
   * 添加文件
   */
  addFile = (files) => {
    let file = files[files.length - 1]
    if (file && file.status === 'done') {
      const { editorState } = this.state;
      let { fileId, name } = file
      const _value = `<div>
      <span style="color:#666"></span>
      <a href="${getOssFilePath(fileId)}" target="_blank" style="font-size:16px;color:#1890ff;cursor: pointer">${name}</a>
      <span style="color:#666"></span>
      </div>`;
      this.setState({
        editorState: braftUtils.ContentUtils.insertHTML(editorState, _value),
        key: new Date().getTime(),
      });
    }
  };

  // 渲染函数
  _render() {
    const { links, extendControls, ...otherProps } = this.props
    const { editorState, linkItems } = this.state

    const _linkItems = links.map(val => linkItems[val])

    const props = {
      showType: 1, // 1模态框 0基础展示
      items: _linkItems,
      onOk: this.handleOk,
      onCancel: () => {this.activeKey = "0"; },
      tabsOpts: {
        onChange: (activeKey) => {
          this.activeKey = activeKey;
        },
      },
      modalOpts: {
        mask: false,
        autoFocusButton: null
      }
    };

    const linksExtendControls = links.length ? [{
      key: "custom-button",
      type: "button",
      title: '内部链接',
      text: <CustomTabs {...props}>内部链接</CustomTabs>,
    }] : []

    const otherExtendControls = [
      {
        key: "custom-preview",
        type: "button",
        title: '预览',
        text: "预览",
        onClick: this.handlePreview,
      },
      {
        key: 'antd-uploader',
        type: 'component',
        component: (
          [<WizOssUpload
            showUploadList={false}
            accept={'.jpg, .jpeg, .png'}
            uploadType={'system'}
            onChange={this.addImg}
          >
            <button type="button" className="control-item button upload-button" data-title="插入图片">
              <WizIcon type="picture" theme="filled" />
            </button>
          </WizOssUpload>,
          <WizOssUpload
            showUploadList={false}
            uploadType={'system'}
            onChange={this.addFile}
          >
            <button type="button" className="control-item button upload-button" data-title="插入文件">
              <WizIcon type="file-add" theme="filled" />
            </button>
          </WizOssUpload>]
        )
      }
    ]

    const _extendControls = links.length ? [
      ...extendControls,
      ...linksExtendControls,
    ] : extendControls


    return (
      <WizBraftEditor
        {...otherProps}
        value={editorState}
        onChange={this.handleChange}
        extendControls={_extendControls.concat(otherExtendControls)}
        ref={(instance) => (this.editorInstance = instance)}
      />
    );
  }
}

// 数据源
const mapStateToProps = (state, ownProps) => {
  return {

  };
};


export default connect(mapStateToProps, null, null, { withRef: true })(WizBraftEditorPlus);


WizBraftEditorPlus.defaultProps = {
  bordered: true,                             // 是否有边框
  placeholder: '请输入内容',                   // placeholder
  excludeControls: ["list-ol", "list-ul", 'media'],    // 工具栏中不包含项
  links: [],                                  // 内链
  extendControls: []                          // 工具栏扩展项
}



class TabForm extends React.Component {
  onSelectedRows = (rows) => {
    const { onSelectedRows } = this.props;
    onSelectedRows && onSelectedRows(rows);
  };

  render() {
    const { name, params } = this.props;
    return (
      <WizTableForm
        {...WizTableForm.Config[name](this, { apiParams: { ...params } })}
        selectType="radio"
        showModal={false}
        onSelectedRows={this.onSelectedRows}
      />
    );
  }
}

TabForm.defaultProps = {
  params: {}
}
